import ora from "ora";

export const spinner = (text: string) => ora({ text });
